import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import classNames from "classnames";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import Select from "react-select";

import {
  getCollectionPrefix,
  getCollectionList,
  getImageBanner,
  getCollectionProductBrands
} from "../../../actions/kafairAction";

import { Banner } from "../../../Container/Assets";
import SneakerImage from "../../../components/Sneakers/SneakerImage";
import SneakerLoadingSpinner from "../../../components/Sneakers/SneakerLoadingSpinner";
import { TextRupiah } from "../../../components/Text";

import { getCloudImageUrl } from "../../../utils";

import GoldSelected from "../../../images/gold.jpg";
import Gold from "../../../images/gold-selected.jpg";
import PurpleSelected from "../../../images/purple.jpg";
import Purple from "../../../images/purple-selected.jpg";
import NotFoundImg from "../../../images/dashboard-empty-state.png";

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return (
      <div>
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  } else {
    return (
      <div className="countdown-wrapper special">
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  }
};

const CardNotFound = () => (
  <Container className="page-container" style={{ display: "flex" }}>
    <div style={{ flex: 1 }}>
      <div className="not-found" style={{ margin: "0 auto" }}>
        <div className="img-wrapper">
          <KickImage src={NotFoundImg} />
        </div>
      </div>
    </div>
  </Container>
);

class SpecialDealsProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      category: "all",
      page: 1,
      prevY: 0,
      slug: this.props.location.state
        ? this.props.location.state.slug
        : "special-deals-gold",
      name: this.props.location.state
        ? this.props.location.state.name
        : "special_deals_gold",
      categoryOptions: [
        { value: "sneakers", label: "Sneakers" },
        { value: "apparels", label: "Apparel" },
        { value: "handbags", label: "Handbags" }
      ],
      rangeOptions: [
        {
          value: {
            start_price: 0,
            end_price: 1000000
          },
          label: "Under IDR 1.000.000"
        },
        {
          value: {
            start_price: 1000000,
            end_price: 3000000
          },
          label: "IDR 1.000.000 - IDR 3.000.000"
        },
        {
          value: {
            start_price: 3000000,
            end_price: ""
          },
          label: "Above IDR 3.000.000"
        }
      ],
      categorySelected: null,
      rangeSelected: null,
      collectionNotFound: false
    };

    this.tabs = [
      {
        heading: "Sneakers",
        category: "sneakers"
      },
      {
        heading: "Apparel",
        category: "apparels"
      },
      {
        heading: "Handbags",
        category: "handbags"
      }
    ];
  }

  componentDidMount() {
    const { slug, name } = this.state;
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.6
    };
    const payload = {
      prefix_slug: slug
    };

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.props.getImageBanner(slug, name);

    this.getProductList();

    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
  }

  componentDidUpdate(prevProps) {
    const { page, category, name } = this.state;
    const {
      data: {
        [name]: { products }
      }
    } = this.props;

    if (
      !products.isFetching &&
      prevProps.data[name].products.isFetching !== products.isFetching
    ) {
      const { status_code } = products;

      if (status_code === 200) {
        this.setState({
          page: page + 1
        });
      }
    }
  }

  handleObserver(entities, observer) {
    const {
      category,
      prevY,
      page,
      name,
      categorySelected,
      rangeSelected
    } = this.state;
    const {
      data: {
        [name]: {
          products: { hasMoreData }
        }
      }
    } = this.props;

    const y = entities[0].boundingClientRect.y;

    if (hasMoreData !== null) {
      if (prevY > y) {
        if (categorySelected || rangeSelected) {
          this.getFilterProduct();
        } else {
          this.getProductList();
        }
      }
      this.setState({ prevY: y });
    }
  }

  getProductList = () => {
    const { match } = this.props;
    const { category, page, slug, name } = this.state;
    const payload = {
      page,
      per_page: 16,
      pre_verified: true
    };

    this.props.getCollectionList(category, slug, payload, name);
  };

  getFilterProduct = () => {
    const { page, name, slug, categorySelected, rangeSelected } = this.state;
    const payload = {
      collection: slug,
      collection_type: "product_variants",
      page,
      per_page: 16,
      pre_verified: true,
      category: categorySelected ? categorySelected.value : "",
      start_price: rangeSelected ? rangeSelected.value.start_price : "",
      end_price: rangeSelected ? rangeSelected.value.end_price : ""
    };

    this.props.getCollectionProductBrands(payload, name);
  };

  onCategoryChange = async selected => {
    await this.setState({
      categorySelected: selected ? selected : null,
      page: 1
    });

    if (selected) {
      this.getFilterProduct();
    }
  };

  onRangeChange = async selected => {
    await this.setState({
      rangeSelected: selected ? selected : null,
      page: 1
    });

    if (selected) {
      this.getFilterProduct();
    }
  };

  onSpecialChange = async (slug, name) => {
    const { categorySelected, rangeSelected } = this.state;

    if (slug === this.state.slug) return;
    const payloadPrefix = {
      prefix_slug: slug,
      limited_time: true
    };
    const dataPrefix = await this.props.getCollectionPrefix(
      payloadPrefix,
      name
    );

    if (
      dataPrefix.value &&
      dataPrefix.value.data &&
      dataPrefix.value.data.data.length > 0
    ) {
      const newSlug = dataPrefix.value.data.data[0].slug;

      this.setState(
        {
          collectionNotFound: false,
          slug: newSlug,
          name
        },
        () => {
          if (categorySelected || rangeSelected) {
            this.getFilterProduct();
          } else {
            this.getProductList();
          }
        }
      );
    } else {
      this.setState({
        collectionNotFound: true,
        name
      });
    }
  };

  renderSpecialHead = () => {
    const { slug, name } = this.state;

    return (
      <Row className="special-head-wrapper">
        <Col md={6}>
          <div
            className="button-special-head-wrapper"
            onClick={() =>
              this.onSpecialChange("special-deals-gold", "special_deals_gold")
            }
          >
            <KickImage src={slug === "special-deals-gold" ? GoldSelected : Gold} />
            <span
              className={classNames({
                "selected-gold": slug !== "special-deals-gold"
              })}
            >
              Gold
            </span>
          </div>
        </Col>
        <Col md={6}>
          <div
            className="button-special-head-wrapper last"
            onClick={() =>
              this.onSpecialChange("capsule-zone", "special_deals_capsule")
            }
          >
            <KickImage src={slug === "capsule-zone" ? PurpleSelected : Purple} />
            <span
              className={classNames({
                "selected-purple": slug !== "capsule-zone"
              })}
            >
              Purple
            </span>
          </div>
        </Col>
      </Row>
    );
  };

  renderTabPage = () => {
    const { name, collectionNotFound } = this.state;
    const {
      data: {
        [name]: {
          products: { data },
          error,
          starts_at
        }
      }
    } = this.props;
    const isStart = moment().isAfter(starts_at);

    if (error || collectionNotFound) return <CardNotFound />;

    if (data.length === 0) return null;

    return (
      <Row className="product-wrapper">
        {data.map((item, index) => {
          const category = item.product.category.name;

          return (
            <Col xs={6} md={4}>
              <a
                href={`/${category}/${item.id}/${item.slug}`}
                style={
                  !item.price || item.out_of_stock || !isStart
                    ? {
                        pointerEvents: "none"
                      }
                    : {}
                }
              >
                <div
                  className={classNames("product-card", {
                    disabled: !item.price || item.out_of_stock || !isStart
                  })}
                >
                  <span>
                    {item.product.brand.title
                      ? item.product.brand.title
                      : item.product.brand.name}
                  </span>
                  <span>{item.display_name}</span>
                  <SneakerImage
                    hasImage={
                      item.product_variant_images.length > 0 ? true : false
                    }
                    src={
                      item.product_variant_images.length
                        ? getCloudImageUrl(
                            item.product_variant_images[0].URL,
                            400
                          )
                        : null
                    }
                    alt={item.display_name}
                  />
                  {item.price ? (
                    <TextRupiah
                      value={item.price}
                      className="price-tag"
                      color="black"
                      bold={true}
                      align="center"
                    />
                  ) : (
                    <span className="text-center">X</span>
                  )}
                </div>
              </a>
            </Col>
          );
        })}
      </Row>
    );
  };

  render() {
    const {
      category,
      name,
      slug,
      categorySelected,
      rangeSelected
    } = this.state;
    const {
      data: {
        [name]: { imageBanner, expiry, starts_at, products }
      },
      match
    } = this.props;
    const isStart = moment().isAfter(starts_at);
    const isExpired = moment().isAfter(expiry);

    return (
      <Container fluid className="main-container" id="home-container">
        <Banner src={imageBanner} alt={slug} />
        <div className="steal-product-container">
          <Container>
            {this.renderSpecialHead()}
            <Row>
              <Col xs={12} md={6}>
                {expiry ? (
                  <>
                    <div className="timer-wrapper special">
                      <span>{isStart ? "BERAKHIR DALAM" : "MULAI DALAM"}</span>
                    </div>
                    <Countdown
                      date={isStart ? expiry : starts_at}
                      daysInHours={true}
                      zeroPadTime={2}
                      renderer={renderer}
                    />
                  </>
                ) : null}
              </Col>
              <Col xs={12} md={6}>
                <Row>
                  <Col md={6}>
                    <Select
                      value={categorySelected}
                      onChange={this.onCategoryChange}
                      options={this.state.categoryOptions}
                      placeholder="Category"
                    />
                  </Col>
                  <Col md={6}>
                    <Select
                      value={rangeSelected}
                      onChange={this.onRangeChange}
                      options={this.state.rangeOptions}
                      placeholder="Range"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            {this.renderTabPage()}
            <div style={{ marginTop: "120px" }}>
              <SneakerLoadingSpinner
                isLoading={products.isFetching && this.state.page > 1}
                isHide={!products.isFetching}
                wrapperRef={loadingRef => (this.loadingRef = loadingRef)}
              />
            </div>
          </Container>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dataKaFair
});

const mapDispatchToProps = dispatch => ({
  getCollectionPrefix: (payload, name) =>
    dispatch(getCollectionPrefix(payload, name)),
  getCollectionList: (category, slug, payload, name) =>
    dispatch(getCollectionList(category, slug, payload, name)),
  getImageBanner: (slug, name) => dispatch(getImageBanner(slug, name)),
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialDealsProduct);
